module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg2-dcd556f426249515cbb5f46bc7c40dcb.png";